import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { clearAuthData, getUserInfoSync, BASE_URL } from '../../config/api'
import logo from '../../assets/logo.jpeg'
import syncEngine from '../../services/syncEngine'

const TopBar = ({ onToggleSidebar, setActiveScreen }) => {
  const navigate = useNavigate()
  const userInfo = getUserInfoSync()
  const companyLogo = userInfo?.company?.logo
  const logoSrc = companyLogo
    ? (companyLogo.startsWith('http') ? companyLogo : `${BASE_URL}${companyLogo}`)
    : logo

  // Get user display name
  const getUserDisplayName = () => {
    if (userInfo?.employee_name) return userInfo.employee_name
    if (userInfo?.full_name) return userInfo.full_name
    if (userInfo?.first_name && userInfo?.last_name) return `${userInfo.first_name} ${userInfo.last_name}`
    if (userInfo?.username) return userInfo.username
    if (userInfo?.email) return userInfo.email.split('@')[0]
    return 'User'
  }

  const handleProfileClick = (e) => {
    e.preventDefault()
    if (setActiveScreen) {
      setActiveScreen('profile')
    }
  }
  const [syncStatus, setSyncStatus] = useState({
    isOnline: navigator.onLine,
    isSyncing: false,
  })

  const handleToggleClick = (e) => {
    e.preventDefault()
    if (onToggleSidebar) {
      onToggleSidebar()
    }
  }

  const handleLogout = (e) => {
    e.preventDefault()
    clearAuthData()
    navigate('/login')
  }

  useEffect(() => {
    const updateStatus = () => {
      const status = syncEngine.getStatus()
      setSyncStatus(status)
    }

    updateStatus()

    // Update more frequently when syncing to show animation
    let interval = setInterval(updateStatus, 1000) // Check every second

    // NOTE: We don't add online/offline listeners here because syncEngine already handles them
    // Adding duplicate listeners causes multiple syncs. syncEngine will handle sync automatically.
    console.log('[TOPBAR] Status update interval started. Sync engine handles online/offline events.')

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-between">
        <a href="index.html" className="logo d-flex align-items-center">
          <img src={logoSrc} alt="Logo" />
          <span className="d-none d-lg-block">{userInfo?.company?.name || 'Sell Smart'}</span>
        </a>
        <i className="bi bi-list toggle-sidebar-btn" onClick={handleToggleClick} style={{ cursor: 'pointer' }} />
      </div>{/* End Logo */}

      <nav className="header-nav ms-auto d-flex align-items-center">
        <div className="me-3">
          {syncStatus.isOnline ? (
            syncStatus.isSyncing ? (
              <div
                className="d-flex align-items-center px-3 py-1 rounded-pill shadow-sm"
                style={{
                  background: '#e6f4ea',
                  border: '1px solid #b6e0c2',
                  columnGap: '0.4rem',
                }}
              >
                <div
                  className="spinner-border spinner-border-sm text-success"
                  role="status"
                  style={{ width: '0.9rem', height: '0.9rem' }}
                >
                  <span className="visually-hidden">Syncing...</span>
                </div>
                <span
                  style={{
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    color: '#1f6f14',
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                  }}
                >
                  Syncing sales...
                </span>
              </div>
            ) : null
          ) : (
            <div
              className="d-flex align-items-center px-3 py-1 rounded-pill shadow-sm"
              style={{
                background: '#fff3cd',
                border: '1px solid #ffeeba',
                columnGap: '0.4rem',
              }}
            >
              <i className="bi bi-wifi-off text-warning" />
              <span
                style={{
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  color: '#856404',
                  letterSpacing: '0.04em',
                  textTransform: 'uppercase',
                }}
              >
                Offline – sales will auto-sync
              </span>
            </div>
          )}
        </div>
        <ul className="d-flex align-items-center">
          <li className="nav-item d-block d-lg-none">
            <a className="nav-link nav-icon search-bar-toggle " href="#">
              <i className="bi bi-search" />
            </a>
          </li>{/* End Search Icon*/}

          <li className="nav-item dropdown pe-3">
            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
              <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" />
              <span className="d-none d-md-block dropdown-toggle ps-2">{getUserDisplayName()}</span>
            </a>{/* End Profile Iamge Icon */}
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
              <li className="dropdown-header">
                <h6>{getUserDisplayName()}</h6>
                <span>{userInfo?.role_display || 'User'}</span>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
                  <i className="bi bi-person" />
                  <span>My Profile</span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                  <i className="bi bi-box-arrow-right" />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>{/* End Profile Dropdown Items */}
          </li>{/* End Profile Nav */}
        </ul>
      </nav>{/* End Icons Navigation */}
    </header>

  )
}

export default TopBar